module.exports = __webpack_public_path__ + "img/musee-grevin.0ea4cfb8.webp";